import { c as _c } from "react/compiler-runtime";
import { FlexColumn } from '@repo/design-system/components/layout/flex-column';
import { Type } from '@repo/design-system/components/ui/type';
import { useT } from '@repo/i18n/components/i18n.client';
import { css } from '@repo/panda/css';
import { useAppSelector } from '@repo/store/maps/hooks';
import { selectIsInCreatorMode } from '@repo/store/maps/slices/mapData';
import { AccordionComponent } from '@repo/ui/components/accordion/accordion';
import { FloatingPanel } from '@repo/ui/components/floating-panel/floating-panel';
import { AddCategoryForm } from './components/add-category-form';
import { AddSubcategoryForm } from './components/add-subcategory-form';
import { BulkEditMapPinsForm } from './components/bulk-edit-map-pins';
import { BulkMoveMapLocationsAction } from './components/bulk-move-map-locations';
import { EditCategoryForm } from './components/edit-category-form';
import { EditSubcategoryForm } from './components/edit-subcategory-form';
import { GameFontTools } from './components/game-font-tools';
import { HeroActions } from './components/hero-actions';
import { ImportCategoriesAndSubcategoriesForm } from './components/import-categories-and-subcategories-form';
import { LabelTools } from './components/label-tools';
import { Object3dTools } from './components/object-3d-tools';
import { PlayerLocationTools } from './components/player-location-tools';
import { QuickActions } from './components/quick-actions';
import { RegionTools } from './components/region-tools';
export const CreatorToolsPanel = () => {
  const $ = _c(63);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["game_map"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useT(t0);
  const isInCreatorMode = useAppSelector(selectIsInCreatorMode);
  if (!isInCreatorMode) {
    return null;
  }
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = css({
      listStyleType: "disc",
      paddingLeft: "12"
    });
    t2 = <li><b>Ctrl + Click</b> to edit pins</li>;
    t3 = <li><b>Shift + Click</b> to add a pin, (or add marker button in bottom right)</li>;
    t4 = <li><b>Move</b> pins using the move button on the bottom right or from the drop down menu on a selected pin</li>;
    t5 = <li><b>Right Click</b> a marker to copy the pin link to use in markdown URL format (use the link icon in the editor)</li>;
    t6 = <li><b>Ctrl + V</b> to paste images or videos directly from your clipboard when editing pins</li>;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t1) {
    t7 = {
      value: "tool-info",
      title: "Creator Tools Info",
      children: <Type variant="body-s" as="div"><ul className={t1}>{t2}{t3}{t4}{t5}{t6}</ul></Type>
    };
    $[7] = t1;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      value: "hero-actions",
      title: "Hero Actions",
      children: <HeroActions />
    };
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      value: "bulk-edit-pins",
      title: "Bulk edit pins",
      children: <BulkEditMapPinsForm />
    };
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t) {
    t10 = t(_temp);
    $[11] = t;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <AddCategoryForm />;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t10) {
    t12 = {
      value: "add-category",
      title: t10,
      children: t11
    };
    $[14] = t10;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== t) {
    t13 = t(_temp2);
    $[16] = t;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <EditCategoryForm />;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] !== t13) {
    t15 = {
      value: "edit-category",
      title: t13,
      children: t14
    };
    $[19] = t13;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  let t16;
  if ($[21] !== t) {
    t16 = t(_temp3);
    $[21] = t;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <AddSubcategoryForm />;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  let t18;
  if ($[24] !== t16) {
    t18 = {
      value: "add-subcategory",
      title: t16,
      children: t17
    };
    $[24] = t16;
    $[25] = t18;
  } else {
    t18 = $[25];
  }
  let t19;
  if ($[26] !== t) {
    t19 = t(_temp4);
    $[26] = t;
    $[27] = t19;
  } else {
    t19 = $[27];
  }
  let t20;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <EditSubcategoryForm />;
    $[28] = t20;
  } else {
    t20 = $[28];
  }
  let t21;
  if ($[29] !== t19) {
    t21 = {
      value: "edit-subcategory",
      title: t19,
      children: t20
    };
    $[29] = t19;
    $[30] = t21;
  } else {
    t21 = $[30];
  }
  let t22;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = {
      value: "import-categories-and-subcategories",
      title: "Import categories and subcategories",
      children: <ImportCategoriesAndSubcategoriesForm />
    };
    $[31] = t22;
  } else {
    t22 = $[31];
  }
  let t23;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = {
      value: "game-font",
      title: "Game-specific font",
      children: <GameFontTools />
    };
    $[32] = t23;
  } else {
    t23 = $[32];
  }
  let t24;
  if ($[33] !== t) {
    t24 = t(_temp5);
    $[33] = t;
    $[34] = t24;
  } else {
    t24 = $[34];
  }
  let t25;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <PlayerLocationTools />;
    $[35] = t25;
  } else {
    t25 = $[35];
  }
  let t26;
  if ($[36] !== t24) {
    t26 = {
      value: "player-location",
      title: t24,
      children: t25
    };
    $[36] = t24;
    $[37] = t26;
  } else {
    t26 = $[37];
  }
  let t27;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = {
      value: "regions",
      title: "Region Tools",
      children: <RegionTools />
    };
    $[38] = t27;
  } else {
    t27 = $[38];
  }
  let t28;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = {
      value: "labels",
      title: "Label Tools",
      children: <LabelTools />
    };
    $[39] = t28;
  } else {
    t28 = $[39];
  }
  let t29;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = {
      value: "3d-objects",
      title: "3D Object Tools",
      children: <Object3dTools />
    };
    $[40] = t29;
  } else {
    t29 = $[40];
  }
  let t30;
  if ($[41] !== t12 || $[42] !== t15 || $[43] !== t18 || $[44] !== t21 || $[45] !== t26 || $[46] !== t7) {
    t30 = [t7, t8, t9, t12, t15, t18, t21, t22, t23, t26, t27, t28, t29];
    $[41] = t12;
    $[42] = t15;
    $[43] = t18;
    $[44] = t21;
    $[45] = t26;
    $[46] = t7;
    $[47] = t30;
  } else {
    t30 = $[47];
  }
  const accordionItems = t30;
  let t31;
  if ($[48] !== t) {
    t31 = t(_temp6);
    $[48] = t;
    $[49] = t31;
  } else {
    t31 = $[49];
  }
  let t32;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = {
      x: window.innerWidth * 0.3,
      y: 90
    };
    $[50] = t32;
  } else {
    t32 = $[50];
  }
  let t33;
  let t34;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = css.raw({
      padding: "8"
    });
    t34 = <QuickActions />;
    $[51] = t33;
    $[52] = t34;
  } else {
    t33 = $[51];
    t34 = $[52];
  }
  let t35;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = [];
    $[53] = t35;
  } else {
    t35 = $[53];
  }
  let t36;
  if ($[54] !== accordionItems) {
    t36 = <AccordionComponent items={accordionItems} variant="dark" size="sm" multiple={true} collapsible={true} defaultValue={t35} />;
    $[54] = accordionItems;
    $[55] = t36;
  } else {
    t36 = $[55];
  }
  let t37;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <BulkMoveMapLocationsAction />;
    $[56] = t37;
  } else {
    t37 = $[56];
  }
  let t38;
  if ($[57] !== t33 || $[58] !== t36) {
    t38 = <FlexColumn gap="8" className={t33}>{t34}{t36}{t37}</FlexColumn>;
    $[57] = t33;
    $[58] = t36;
    $[59] = t38;
  } else {
    t38 = $[59];
  }
  let t39;
  if ($[60] !== t31 || $[61] !== t38) {
    t39 = <FloatingPanel isOpen={true} title={t31} variant="dark" draggable={true} resizable={true} collapsible={true} isCollapsed={true} hideCloseButton={true} position={t32} defaultWidth={350} defaultHeight={400}>{t38}</FloatingPanel>;
    $[60] = t31;
    $[61] = t38;
    $[62] = t39;
  } else {
    t39 = $[62];
  }
  return t39;
};
function _temp($) {
  return $.add_category;
}
function _temp2($_0) {
  return $_0.edit_category;
}
function _temp3($_1) {
  return $_1.add_subcategory;
}
function _temp4($_2) {
  return $_2.edit_subcategory;
}
function _temp5($_3) {
  return $_3.player_location_tools.player_location_tools;
}
function _temp6($_4) {
  return $_4.creator_tools;
}